import _ from 'lodash';

export function formatRadarMetricSeries(metricSeries, metrics, groupBy) {
    const formattedKeyedByMetric = {};

    metricSeries.forEach(dataPoint => {
        _.forEach(dataPoint, (value, key) => {
            if (!metrics.includes(key)) {
                return;
            }

            formattedKeyedByMetric[key] = {
                ...formattedKeyedByMetric[key],
                metric: key,
                [dataPoint[groupBy]]: value
            };
        });
    });

    return _.values(formattedKeyedByMetric);
}
